/* eslint-disable @typescript-eslint/no-explicit-any */
declare let require: any;
// eslint-disable-next-line @typescript-eslint/no-var-requires
const GeoJSON = require("geojson");

export const point = (points: CoordinateObject[]): any => {
    return GeoJSON.parse(points, { Point: "coordinates", id: "id" });
};

export const lineString = (linestringDict: CoordinateObject[]): any => {
    return GeoJSON.parse(linestringDict, {
        LineString: "coordinates",
        id: "id",
    });
};

export const multilineString = (multilineDict: CoordinateObject[]): any => {
    return GeoJSON.parse(multilineDict, {
        MultiLineString: "coordinates",
        id: "id",
    });
};

export const emptyGeojsonObject = (): any => {
    return GeoJSON.parse([], { Point: "coordinates", id: "id" });
};

export interface CoordinateObject {
    id: string;
    coordinates:
        | PointCoordinates
        | LineStringCoordinates
        | MultiLineStringCoordinates;
}

export type PointCoordinates = [number, number];
export type LineStringCoordinates = PointCoordinates[];
export type MultiLineStringCoordinates = LineStringCoordinates[];
